import React from "react";

import { useSelector } from "../../utils/hooks";
import { FlexInsurance } from "../products/FlexInsurance";
import { Insurance } from "../products/Insurance";
import "./Modal.scss";

export const NewInsuranceModal = () => {
	const productId = useSelector(
		(state) => state.popup.products.mainProduct.insuranceProductId,
	);

	const isFlexInsurance = useSelector(
		(state) => state.popup.products.mainProduct.isFlexInsurance,
	);

	return (
		<div className="addtocartpopupModal--container">
			<div className="addtocartpopupModal--iconcontainer">
				<img data-testid="product-image" src={`/img/p/400/${productId}.jpg`} />
			</div>
			<div className="addtocartpopupModal--row">
				{isFlexInsurance ? <FlexInsurance /> : <Insurance />}
			</div>
		</div>
	);
};
